import { ShowModalOptions } from '@ui-common/components/Modal'
import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { BodyText } from '@ui-components/typography/Typography'
import { IntlShape } from 'react-intl'

export const getApplicationForLoanExistsErrorEvent = ({
  onPromptConfirm,
  onGoToApplications,
  formatMessage,
  requestId,
}: {
  onPromptConfirm: () => void
  onGoToApplications: () => void
  formatMessage: IntlShape['formatMessage']
  requestId: string
}): ShowModalOptions => ({
  header: formatMessage({ id: 'ifp-application-for-loan-exists-error-header' }),
  children: <BodyText tagName="p">{formatMessage({ id: 'ifp-application-for-loan-exists-error-text' })}</BodyText>,
  primaryButtonOptions: {
    label: formatMessage({ id: 'ifp-application-for-loan-exists-error-primary-button' }),
    onClick: onGoToApplications,
  },
  secondaryButtonOptions: {
    label: formatMessage({ id: 'common-ok' }),
    onClick: onPromptConfirm,
  },
  requestId,
  mode: ModalVisualMode.Plain,
})

export const getOtherNonTechnicalErrorEvent = ({
  onPromptConfirm,
  formatMessage,
  requestId,
}: {
  onPromptConfirm: () => void
  formatMessage: IntlShape['formatMessage']
  requestId: string
}): ShowModalOptions => ({
  header: formatMessage({ id: 'common-non-technical-error-heading' }),
  children: <BodyText tagName="p">{formatMessage({ id: 'common-non-technical-error-text' })}</BodyText>,
  primaryButtonOptions: {
    label: formatMessage({ id: 'common-ok' }),
    onClick: onPromptConfirm,
    type: 'secondary',
  },
  requestId,
  mode: ModalVisualMode.Plain,
})
